module.exports = __webpack_public_path__ + "img/img-19.9cc0af3e.png";